import React from "react";

const AvatarCard = ({ item, styles }) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const coloum_value = JSON.parse(item?.coloum_value);
  const avatarStyles = styles?.filter(
    (item) => item?.coloum_name === "avatar"
  )?.[0] || null;
  const styles_coloum_value = avatarStyles?.coloum_value && JSON.parse(avatarStyles?.coloum_value);

  return (
    <div className="flex justify-center">
      <img 
      style={{ borderStyle : styles_coloum_value?.avatar_outline?.outline_style, borderColor:styles_coloum_value?.avatar_outline?.outline_colour }}
        className={`object-cover ${
          styles_coloum_value?.avatar_size
            ? styles_coloum_value?.avatar_size === "75x75"
              ? "max-h-[75px] min-h-[75px] h-[75px] max-w-[75px] min-w-[75px] w-[75px]"
              : styles_coloum_value?.avatar_size === "100x100"
              ? "max-h-[100px] min-h-[100px] h-[100px] max-w-[100px] min-w-[100px] w-[100px]"
              : styles_coloum_value?.avatar_size === "125x125"
              ? "max-h-[125px] min-h-[125px] h-[125px] max-w-[125px] min-w-[125px] w-[125px]"
              : "max-h-[150px] min-h-[150px] h-[150px] max-w-[150px] min-w-[150px] w-[150px]"
            : coloum_value?.size === "75x75"
            ? "max-h-[75px] min-h-[75px] h-[75px] max-w-[75px] min-w-[75px] w-[75px]"
            : coloum_value?.size === "100x100"
            ? "max-h-[100px] min-h-[100px] h-[100px] max-w-[100px] min-w-[100px] w-[100px]"
            : coloum_value?.size === "125x125"
            ? "max-h-[125px] min-h-[125px] h-[125px] max-w-[125px] min-w-[125px] w-[125px]"
            : "max-h-[150px] min-h-[150px] h-[150px] max-w-[150px] min-w-[150px] w-[150px]"
        } ${
          styles_coloum_value?.avatar_shape
            ? styles_coloum_value?.avatar_shape === "rounded"
              ? "rounded-lg"
              : styles_coloum_value?.avatar_shape === "circle"
              ? "rounded-full"
              : "rounded-none"
            : coloum_value?.radius === "rounded"
            ? "rounded-lg"
            : coloum_value?.radius === "circle"
            ? "rounded-full"
            : "rounded-none"
        } ${
          styles_coloum_value?.avatar_outline
            ? `${
                styles_coloum_value?.avatar_outline?.outline_width === "8px"
                  ? "border-8"
                  : styles_coloum_value?.avatar_outline?.outline_width === "4px"
                  ? "border-4"
                  : styles_coloum_value?.avatar_outline?.outline_width === "2px"
                  ? "border-2"
                  : "border"
              } border-${
                styles_coloum_value?.avatar_outline?.outline_style
              } border-[${styles_coloum_value?.avatar_outline?.outline_colour}]`
            : ""
        }`}
        src={`${
          coloum_value?.name ? baseUrl + "/profile/" + coloum_value?.name : ""
        }`}
        
        alt="avatar" title="Avatar"
       />
    </div>
  );
};

export default AvatarCard;
